import { render, staticRenderFns } from "./ChoosenPlan.vue?vue&type=template&id=7932a1ec&scoped=true&"
import script from "./ChoosenPlan.vue?vue&type=script&lang=js&"
export * from "./ChoosenPlan.vue?vue&type=script&lang=js&"
import style0 from "./ChoosenPlan.vue?vue&type=style&index=0&id=7932a1ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7932a1ec",
  null
  
)

export default component.exports